module.exports = __webpack_public_path__ + "img/badge.b9e16f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/badge.png
// module id = uLC9
// module chunks = 15